import routeParams from '../../../helpers/routeParams'

const GET_LIST = 'dofe-bo/LABEL/GET_LIST'
const GET_LIST_SUCCESS = 'dofe-bo/LABEL/GET_LIST_SUCCESS'
const GET_LIST_FAIL = 'dofe-bo/LABEL/GET_LIST_FAIL'

const GET_AVAILABLE_LABEL_LIST = 'dofe-bo/LABEL/GET_AVAILABLE_LABEL_LIST'
const GET_AVAILABLE_LABEL_LIST_SUCCESS = 'dofe-bo/LABEL/GET_AVAILABLE_LABEL_LIST_SUCCESS'
const GET_AVAILABLE_LABEL_LIST_FAIL = 'dofe-bo/LABEL/GET_AVAILABLE_LABEL_LIST_FAIL'

const GET_SEARCH_LABEL_LIST = 'dofe-bo/LABEL/GET_SEARCH_LABEL_LIST'
const GET_SEARCH_LABEL_LIST_SUCCESS = 'dofe-bo/LABEL/GET_SEARCH_LABEL_LIST_SUCCESS'
const GET_SEARCH_LABEL_LIST_FAIL = 'dofe-bo/LABEL/GET_SEARCH_LABEL_LIST_FAIL'

const GET_PERSON_LABELS_LIST = 'dofe-bo/LABEL/GET_PERSON_LABELS_LIST'
const GET_PERSON_LABELS_LIST_SUCCESS = 'dofe-bo/LABEL/GET_PERSON_LABELS_LIST_SUCCESS'
const GET_PERSON_LABELS_LIST_FAIL = 'dofe-bo/LABEL/GET_PERSON_LABELS_LIST_FAIL'

const GET_ORGANIZATION_LABELS_LIST = 'dofe-bo/LABEL/GET_ORGANIZATION_LABELS_LIST'
const GET_ORGANIZATION_LABELS_LIST_SUCCESS = 'dofe-bo/LABEL/GET_ORGANIZATION_LABELS_LIST_SUCCESS'
const GET_ORGANIZATION_LABELS_LIST_FAIL = 'dofe-bo/LABEL/GET_ORGANIZATION_LABELS_LIST_FAIL'

const GET_CONTACT_LABELS_LIST = 'dofe-bo/LABEL/GET_CONTACT_LABELS_LIST'
const GET_CONTACT_LABELS_LIST_SUCCESS = 'dofe-bo/LABEL/GET_CONTACT_LABELS_LIST_SUCCESS'
const GET_CONTACT_LABELS_LIST_FAIL = 'dofe-bo/LABEL/GET_CONTACT_LABELS_LIST_FAIL'

const GET_AWARD_LABELS_LIST = 'dofe-bo/LABEL/GET_AWARD_LABELS_LIST'
const GET_AWARD_LABELS_LIST_SUCCESS = 'dofe-bo/LABEL/GET_AWARD_LABELS_LIST_SUCCESS'
const GET_AWARD_LABELS_LIST_FAIL = 'dofe-bo/LABEL/GET_AWARD_LABELS_LIST_FAIL'

const CREATE_LABEL = 'dofe-bo/LABEL/CREATE_LABEL'
const CREATE_LABEL_SUCCESS = 'dofe-bo/LABEL/CREATE_LABEL_SUCCESS'
const CREATE_LABEL_FAIL = 'dofe-bo/LABEL/CREATE_LABEL_FAIL'

const UPDATE_LABEL = 'dofe-bo/LABEL/UPDATE_LABEL'
const UPDATE_LABEL_SUCCESS = 'dofe-bo/LABEL/UPDATE_LABEL_SUCCESS'
const UPDATE_LABEL_FAIL = 'dofe-bo/LABEL/UPDATE_LABEL_FAIL'

const DELETE_LABEL = 'dofe-bo/LABEL/DELETE_LABEL'
const DELETE_LABEL_SUCCESS = 'dofe-bo/LABEL/DELETE_LABEL_SUCCESS'
const DELETE_LABEL_FAIL = 'dofe-bo/LABEL/DELETE_LABEL_FAIL'

const SET_FILTER = 'dofe-bo/LABEL/SET_FILTER'

const ASSIGN_PERSON_LABEL_BULK = 'dofe-bo/LABEL/ASSIGN_PERSON_LABEL_BULK'
const ASSIGN_PERSON_LABEL_BULK_SUCCESS = 'dofe-bo/LABEL/ASSIGN_PERSON_LABEL_BULK_SUCCESS'
const ASSIGN_PERSON_LABEL_BULK_FAIL = 'dofe-bo/LABEL/ASSIGN_PERSON_LABEL_BULK_FAIL'

const UNASSIGN_PERSON_LABEL_BULK = 'dofe-bo/LABEL/UNASSIGN_PERSON_LABEL_BULK'
const UNASSIGN_PERSON_LABEL_BULK_SUCCESS = 'dofe-bo/LABEL/UNASSIGN_PERSON_LABEL_BULK_SUCCESS'
const UNASSIGN_PERSON_LABEL_BULK_FAIL = 'dofe-bo/LABEL/UNASSIGN_PERSON_LABEL_BULK_FAIL'

const ASSIGN_PERSON_LABEL = 'dofe-bo/LABEL/ASSIGN_PERSON_LABEL'
const ASSIGN_PERSON_LABEL_SUCCESS = 'dofe-bo/LABEL/ASSIGN_PERSON_LABEL_SUCCESS'
const ASSIGN_PERSON_LABEL_FAIL = 'dofe-bo/LABEL/ASSIGN_PERSON_LABEL_FAIL'

const UNASSIGN_PERSON_LABEL = 'dofe-bo/LABEL/UNASSIGN_PERSON_LABEL'
const UNASSIGN_PERSON_LABEL_SUCCESS = 'dofe-bo/LABEL/UNASSIGN_PERSON_LABEL_SUCCESS'
const UNASSIGN_PERSON_LABEL_FAIL = 'dofe-bo/LABEL/UNASSIGN_PERSON_LABEL_FAIL'

const ASSIGN_ORGANIZATION_LABEL = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_LABEL'
const ASSIGN_ORGANIZATION_LABEL_SUCCESS = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_LABEL_SUCCESS'
const ASSIGN_ORGANIZATION_LABEL_FAIL = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_LABEL_FAIL'

const UNASSIGN_ORGANIZATION_LABEL = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_LABEL'
const UNASSIGN_ORGANIZATION_LABEL_SUCCESS = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_LABEL_SUCCESS'
const UNASSIGN_ORGANIZATION_LABEL_FAIL = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_LABEL_FAIL'

const ASSIGN_ORGANIZATION_LABEL_BULK = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_LABEL_BULK'
const ASSIGN_ORGANIZATION_LABEL_BULK_SUCCESS = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_LABEL_BULK_SUCCESS'
const ASSIGN_ORGANIZATION_LABEL_BULK_FAIL = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_LABEL_BULK_FAIL'

const UNASSIGN_ORGANIZATION_LABEL_BULK = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_LABEL_BULK'
const UNASSIGN_ORGANIZATION_LABEL_BULK_SUCCESS = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_LABEL_BULK_SUCCESS'
const UNASSIGN_ORGANIZATION_LABEL_BULK_FAIL = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_LABEL_BULK_FAIL'

const ASSIGN_CONTACT_LABEL = 'dofe-bo/LABEL/ASSIGN_CONTACT_LABEL'
const ASSIGN_CONTACT_LABEL_SUCCESS = 'dofe-bo/LABEL/ASSIGN_CONTACT_LABEL_SUCCESS'
const ASSIGN_CONTACT_LABEL_FAIL = 'dofe-bo/LABEL/ASSIGN_CONTACT_LABEL_FAIL'

const UNASSIGN_CONTACT_LABEL = 'dofe-bo/LABEL/UNASSIGN_CONTACT_LABEL'
const UNASSIGN_CONTACT_LABEL_SUCCESS = 'dofe-bo/LABEL/UNASSIGN_CONTACT_LABEL_SUCCESS'
const UNASSIGN_CONTACT_LABEL_FAIL = 'dofe-bo/LABEL/UNASSIGN_CONTACT_LABEL_FAIL'

const ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK'
const ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_SUCCESS = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_SUCCESS'
const ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_FAIL = 'dofe-bo/LABEL/ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_FAIL'

const UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK'
const UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_SUCCESS = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_SUCCESS'
const UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_FAIL = 'dofe-bo/LABEL/UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_FAIL'


const ASSIGN_AWARD_LABEL = 'dofe-bo/LABEL/ASSIGN_AWARD_LABEL'
const ASSIGN_AWARD_LABEL_SUCCESS = 'dofe-bo/LABEL/ASSIGN_AWARD_LABEL_SUCCESS'
const ASSIGN_AWARD_LABEL_FAIL = 'dofe-bo/LABEL/ASSIGN_AWARD_LABEL_FAIL'

const UNASSIGN_AWARD_LABEL = 'dofe-bo/LABEL/UNASSIGN_AWARD_LABEL'
const UNASSIGN_AWARD_LABEL_SUCCESS = 'dofe-bo/LABEL/UNASSIGN_AWARD_LABEL_SUCCESS'
const UNASSIGN_AWARD_LABEL_FAIL = 'dofe-bo/LABEL/UNASSIGN_AWARD_LABEL_FAIL'

const ASSIGN_AWARD_LABEL_BULK = 'dofe-bo/LABEL/ASSIGN_AWARD_LABEL_BULK'
const ASSIGN_AWARD_LABEL_BULK_SUCCESS = 'dofe-bo/LABEL/ASSIGN_AWARD_LABEL_BULK_SUCCESS'
const ASSIGN_AWARD_LABEL_BULK_FAIL = 'dofe-bo/LABEL/ASSIGN_AWARD_LABEL_BULK_FAIL'

const UNASSIGN_AWARD_LABEL_BULK = 'dofe-bo/LABEL/UNASSIGN_AWARD_LABEL_BULK'
const UNASSIGN_AWARD_LABEL_BULK_SUCCESS = 'dofe-bo/LABEL/UNASSIGN_AWARD_LABEL_BULK_SUCCESS'
const UNASSIGN_AWARD_LABEL_BULK_FAIL = 'dofe-bo/LABEL/UNASSIGN_AWARD_LABEL_BULK_FAIL'


const SET_PARAMS = 'dofe-bo/LEADER/SET_PARAMS'

const initialState = {
  list: [],
  person: {
    list: [],
    loading: false,
    loaded: false,
    pages: 1,
    count: null
  },
  organization: {
        list: [],
        loading: false,
        loaded: false,
        pages: 1,
        count: null,
    },
  contact: {
        list: [],
        loading: false,
        loaded: false,
        pages: 1,
        count: null
    },
  award: {
    list: [],
    loading: false,
    loaded: false,
    pages: 1,
    count: null
  },
    available: {
    list: [],
    loading: false,
    loaded: false,
    pages: 1,
    count: null
   },
   bulk: {
        loading: false,
        loaded: false
    },
  searchList: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: Number(action.headers['x-total-count']),
        pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
      }
    case GET_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
      case GET_AVAILABLE_LABEL_LIST:
          return {
              ...state,
              available: {
                  loading: true
              }
          }
      case GET_AVAILABLE_LABEL_LIST_SUCCESS:
          return {
              ...state,
              available: {
                  loading: false,
                  loaded: true,
                  list: action.result,
                  count: Number(action.headers['x-total-count']),
                  pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
              }
          }
      case GET_AVAILABLE_LABEL_LIST_FAIL:
          return {
              ...state,
              available: {
                  loading: false,
                  loaded: false,
                  error: action.error
              }
          }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy
      })
      case SET_PARAMS:
          return {
              ...state,
              limit:
                  action.options.limit !== undefined
                      ? action.options.limit
                      : state.limit,
              offset:
                  action.options.offset !== undefined
                      ? action.options.offset
                      : state.offset,
              filter:
                  action.options.filter !== undefined
                      ? action.options.filter
                      : state.filter,
              sort:
                  action.options.sort !== undefined ? action.options.sort : state.sort
          }
    case GET_SEARCH_LABEL_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_SEARCH_LABEL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        searchList: action.result,
        count: Number(action.headers['x-total-count']),
        pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
      }
    case GET_SEARCH_LABEL_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_PERSON_LABELS_LIST:
      return {
        ...state,
        person: {
          loading: true
        }
      }
    case GET_PERSON_LABELS_LIST_SUCCESS:
      return {
        ...state,

        person: {
          loading: false,
          loaded: true,
          list: action.result,
          count: Number(action.headers['x-total-count']),
          pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
        }
      }
    case GET_PERSON_LABELS_LIST_FAIL:
      return {
        ...state,
        person: {
          loading: false,
          loaded: false,
          error: action.error
        }
      }
      case GET_ORGANIZATION_LABELS_LIST:
          return {
              ...state,
              organization: {
                  loading: true
              }
          }
      case GET_ORGANIZATION_LABELS_LIST_SUCCESS:
          return {
              ...state,

              organization: {
                  loading: false,
                  loaded: true,
                  list: action.result,
                  count: Number(action.headers['x-total-count']),
                  pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
              }
          }
      case GET_ORGANIZATION_LABELS_LIST_FAIL:
          return {
              ...state,
              organization: {
                  loading: false,
                  loaded: false,
                  error: action.error
              }
          }
      case GET_CONTACT_LABELS_LIST:
          return {
              ...state,
              contact: {
                  loading: true
              }
          }
      case GET_CONTACT_LABELS_LIST_SUCCESS:
          return {
              ...state,
              contact: {
                  loading: false,
                  loaded: true,
                  list: action.result,
                  count: Number(action.headers['x-total-count']),
                  pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
              }
          }
      case GET_CONTACT_LABELS_LIST_FAIL:
          return {
              ...state,
              contact: {
                  loading: false,
                  loaded: false,
                  error: action.error
              }
          }
    case GET_AWARD_LABELS_LIST:
      return {
        ...state,
        award: {
          loading: true
        }
      }
    case GET_AWARD_LABELS_LIST_SUCCESS:
      return {
        ...state,
        award: {
          loading: false,
          loaded: true,
          list: action.result,
          count: Number(action.headers['x-total-count']),
          pages: Math.ceil(Number(action.headers['x-total-count']) / state.limit) || state.pages
        }
      }
    case GET_AWARD_LABELS_LIST_FAIL:
      return {
        ...state,
        award: {
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case CREATE_LABEL:
      return {
        ...state,
        loading: true
      }
    case CREATE_LABEL_FAIL:
    case CREATE_LABEL_SUCCESS:
      return {
        ...state,
        loading: false
      }
      case UPDATE_LABEL:
          return {
              ...state,
              loading: true
          }
      case UPDATE_LABEL_FAIL:
          return {
              ...state,
              loading: false,
              loaded: false,
              error: action.error
          }
      case UPDATE_LABEL_SUCCESS:
          return {
              ...state,
              loading: false
          }
      case ASSIGN_PERSON_LABEL:
          return {
              ...state,
              loading: true
          }
      case ASSIGN_PERSON_LABEL_FAIL:
          return {
              ...state,
              loading: false,
              loaded: false,
              error: action.error
          }
      case ASSIGN_PERSON_LABEL_SUCCESS:
          return {
              ...state,
              loading: false
          }
      case ASSIGN_ORGANIZATION_LABEL:
          return {
              ...state,
              loading: true
          }
      case ASSIGN_ORGANIZATION_LABEL_FAIL:
          return {
              ...state,
              loading: false,
              loaded: false,
              error: action.error
          }
      case ASSIGN_ORGANIZATION_LABEL_SUCCESS:
          return {
              ...state,
              loading: false
          }
      case ASSIGN_CONTACT_LABEL:
          return {
              ...state,
              loading: true
          }
      case ASSIGN_CONTACT_LABEL_FAIL:
          return {
              ...state,
              loading: false,
              loaded: false,
              error: action.error
          }
      case ASSIGN_CONTACT_LABEL_SUCCESS:
          return {
              ...state,
              loading: false
          }
      case ASSIGN_PERSON_LABEL_BULK:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: true,
                  loaded: false
              }
          }
      case ASSIGN_PERSON_LABEL_BULK_FAIL:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  error: action.error
              }
          }
      case ASSIGN_PERSON_LABEL_BULK_SUCCESS:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  loaded: true,
                  detail: action.result
              }
          }
      case UNASSIGN_PERSON_LABEL_BULK:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: true,
                  loaded: false
              }
          }
      case UNASSIGN_PERSON_LABEL_BULK_FAIL:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  error: action.error
              }
          }
      case UNASSIGN_PERSON_LABEL_BULK_SUCCESS:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  loaded: true,
                  detail: action.result
              }
          }
      case UNASSIGN_PERSON_LABEL:
          return {
              ...state,
              loading: true
          }
      case UNASSIGN_PERSON_LABEL_FAIL:
          return {
              ...state,
              loading: false,
              loaded: false,
              error: action.error
          }
      case UNASSIGN_PERSON_LABEL_SUCCESS:
          return {
              ...state,
              loading: false
          }
      case UNASSIGN_ORGANIZATION_LABEL:
          return {
              ...state,
              loading: true
          }
      case UNASSIGN_ORGANIZATION_LABEL_FAIL:
          return {
              ...state,
              loading: false,
              loaded: false,
              error: action.error
          }
      case UNASSIGN_ORGANIZATION_LABEL_SUCCESS:
          return {
              ...state,
              loading: false
          }
      case ASSIGN_ORGANIZATION_LABEL_BULK:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: true,
                  loaded: false
              }
          }
      case ASSIGN_ORGANIZATION_LABEL_BULK_FAIL:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  error: action.error
              }
          }
      case ASSIGN_ORGANIZATION_LABEL_BULK_SUCCESS:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  loaded: true,
                  detail: action.result
              }
          }
      case UNASSIGN_ORGANIZATION_LABEL_BULK:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: true,
                  loaded: false
              }
          }
      case UNASSIGN_ORGANIZATION_LABEL_BULK_FAIL:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  error: action.error
              }
          }
      case UNASSIGN_ORGANIZATION_LABEL_BULK_SUCCESS:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  loaded: true,
                  detail: action.result
              }
          }
      case UNASSIGN_CONTACT_LABEL:
          return {
              ...state,
              loading: true
          }
      case UNASSIGN_CONTACT_LABEL_FAIL:
          return {
              ...state,
              loading: false,
              loaded: false,
              error: action.error
          }
      case UNASSIGN_CONTACT_LABEL_SUCCESS:
          return {
              ...state,
              loading: false
          }
      case ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: true,
                  loaded: false
              }
          }
      case ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_FAIL:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  error: action.error
              }
          }
      case ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_SUCCESS:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  loaded: true,
                  detail: action.result
              }
          }
      case UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: true,
                  loaded: false
              }
          }
      case UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_FAIL:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  error: action.error
              }
          }
      case UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_SUCCESS:
          return {
              ...state,
              bulk: {
                  ...state.bulk,
                  loading: false,
                  loaded: true,
                  detail: action.result
              }
          }
    default:
      return state
  }
}

export function getPersonLabels(id) {
  return {
    types: [GET_PERSON_LABELS_LIST, GET_PERSON_LABELS_LIST_SUCCESS, GET_PERSON_LABELS_LIST_FAIL],
    promise: client => client.get(`api/labels/person/${id}/available-list`)
  }
}

export function getOrganizationLabels(id) {
    return {
        types: [GET_ORGANIZATION_LABELS_LIST, GET_ORGANIZATION_LABELS_LIST_SUCCESS, GET_ORGANIZATION_LABELS_LIST_FAIL],
        promise: client => client.get(`api/labels/organization/${id}/available-list`)
    }
}

export function getContactLabels(id) {
    return {
        types: [GET_CONTACT_LABELS_LIST, GET_CONTACT_LABELS_LIST_SUCCESS, GET_CONTACT_LABELS_LIST_FAIL],
        promise: client => client.get(`api/labels/organization-contact/${id}/available-list`)
    }
}

export function getAwardLabels(id) {
  return {
    types: [GET_AWARD_LABELS_LIST, GET_AWARD_LABELS_LIST_SUCCESS, GET_AWARD_LABELS_LIST_FAIL],
    promise: client => client.get(`api/labels/award/${id}/available-list`)
  }
}

export function getLabels(params = {}, orgId, filter) {
  return {
    types: [GET_LIST, GET_LIST_SUCCESS, GET_LIST_FAIL],
    promise: client => client.get(`api/labels/${orgId}/list?with=ORGANIZATION_DETAIL${routeParams(params, filter)}`)
  }
}

export function getLabelsInHierarchy(params = {}, filter) {
    return {
        types: [GET_LIST, GET_LIST_SUCCESS, GET_LIST_FAIL],
        promise: client => client.get(`api/labels/hierarchy-list?with=ORGANIZATION_DETAIL${routeParams(params, filter)}`)
    }
}

export function getAvailableLabels(data) {
    return {
        types: [GET_AVAILABLE_LABEL_LIST, GET_AVAILABLE_LABEL_LIST_SUCCESS, GET_AVAILABLE_LABEL_LIST_FAIL],
        promise: client => client.post('api/labels/available-list', { data })
    }
}

export function searchLabels(labelType, params, activeOrgId) {
  let filter = `filter=category.value=${labelType},organization.id=${activeOrgId}`

  if (params.filter) {
    filter = `filter=category.value=${labelType},organization.id=${activeOrgId}` + ',' + params.filter
  }
  return {
    types: [GET_SEARCH_LABEL_LIST, GET_SEARCH_LABEL_LIST_SUCCESS, GET_SEARCH_LABEL_LIST_FAIL],
    promise: client => client.get(`api/labels/hierarchy-list?${filter}`)
  }
}

export function createLabel(orgId, values) {
  const data = {
    orgId,
    name: values.name,
    description: values.description,
    category: values.category,
    isReserved: values.isReserved
  }

  return {
    types: [CREATE_LABEL, CREATE_LABEL_SUCCESS, CREATE_LABEL_FAIL],
    promise: client => client.put('api/labels/create', { data })
  }
}

export function deleteLabel(id) {
  return {
    types: [DELETE_LABEL, DELETE_LABEL_SUCCESS, DELETE_LABEL_FAIL],
    promise: client => client.del(`api/labels/${id}/delete`)
  }
}

export function updateLabel(id, values) {
    const data = {
        name: values.name,
        description: values.description,
        category: null
    }

    return {
        types: [UPDATE_LABEL, UPDATE_LABEL_SUCCESS, UPDATE_LABEL_FAIL],
        promise: client => client.post(`api/labels/${id}/update`, { data })
    }
}

export function setLabelsFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function assignPersonLabelBulk(personIds, labelsIds) {
    const data = {
        personIds,
        labelsIds
    }

    return {
        types: [ASSIGN_PERSON_LABEL_BULK, ASSIGN_PERSON_LABEL_BULK_SUCCESS, ASSIGN_PERSON_LABEL_BULK_FAIL],
        promise: client => client.put('api/labels/person/assign/bulk', { data })
    }
}

export function unassignPersonLabelBulk(personIds, labelsIds) {
    const data = {
        personIds,
        labelsIds
    }

    return {
        types: [UNASSIGN_PERSON_LABEL_BULK, UNASSIGN_PERSON_LABEL_BULK_SUCCESS, UNASSIGN_PERSON_LABEL_BULK_FAIL],
        promise: client => client.post('api/labels/person/unassign/bulk', { data })
    }
}


export function assignPersonLabel(personId, labelId) {
    return {
        types: [ASSIGN_PERSON_LABEL, ASSIGN_PERSON_LABEL_SUCCESS, ASSIGN_PERSON_LABEL_FAIL],
        promise: client => client.put(`api/labels/person/${personId}/assign/${labelId}`, {})
    }
}

export function unassignPersonLabel(personLabelId) {
    return {
        types: [UNASSIGN_PERSON_LABEL, UNASSIGN_PERSON_LABEL_SUCCESS, UNASSIGN_PERSON_LABEL_FAIL],
        promise: client => client.del(`api/labels/person/unassign/${personLabelId}`, {})
    }
}

export function assignOrganizationLabel(orgId, labelId) {
    return {
        types: [ASSIGN_ORGANIZATION_LABEL, ASSIGN_ORGANIZATION_LABEL_SUCCESS, ASSIGN_ORGANIZATION_LABEL_FAIL],
        promise: client => client.put(`api/labels/organization/${orgId}/assign/${labelId}`, {})
    }
}

export function unassignOrganizationLabel(organizationLabelId) {
    return {
        types: [UNASSIGN_ORGANIZATION_LABEL, ASSIGN_ORGANIZATION_LABEL_BULK_SUCCESS, ASSIGN_ORGANIZATION_LABEL_BULK_FAIL],
        promise: client => client.del(`api/labels/organization/unassign/${organizationLabelId}`, {})
    }
}

export function assignOrganizationLabelBulk(organizationIds, labelsIds) {
    const data = {
        organizationIds,
        labelsIds
    }

    return {
        types: [ASSIGN_ORGANIZATION_LABEL_BULK, ASSIGN_PERSON_LABEL_BULK_SUCCESS, ASSIGN_PERSON_LABEL_BULK_FAIL],
        promise: client => client.put('api/labels/organization/assign/bulk', { data })
    }
}

export function unassignOrganizationLabelBulk(organizationIds, labelsIds) {
    const data = {
        organizationIds,
        labelsIds
    }

    return {
        types: [UNASSIGN_ORGANIZATION_LABEL_BULK, UNASSIGN_ORGANIZATION_LABEL_BULK_SUCCESS, UNASSIGN_ORGANIZATION_LABEL_BULK_FAIL],
        promise: client => client.post('api/labels/organization/unassign/bulk', { data })
    }
}


export function assignContactLabel(contactId, labelId) {
    return {
        types: [ASSIGN_CONTACT_LABEL, ASSIGN_CONTACT_LABEL_SUCCESS, ASSIGN_CONTACT_LABEL_FAIL],
        promise: client => client.put(`api/labels/organization-contact/${contactId}/assign/${labelId}`, {})
    }
}

export function unassignContactLabel(id) {
    return {
        types: [UNASSIGN_CONTACT_LABEL, UNASSIGN_CONTACT_LABEL_SUCCESS, UNASSIGN_CONTACT_LABEL_FAIL],
        promise: client => client.del(`api/labels/organization-contact/unassign/${id}`, {})
    }
}

export function assignContactLabelBulk(organizationContactIds, labelsIds) {
    const data = {
        organizationContactIds,
        labelsIds
    }

    return {
        types: [ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK, ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_SUCCESS, ASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_FAIL],
        promise: client => client.put('api/labels/organization-contact/assign/bulk', { data })
    }
}

export function unassignContactLabelBulk(organizationContactIds, labelsIds) {
    const data = {
        organizationContactIds,
        labelsIds
    }

    return {
        types: [UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK, UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_SUCCESS, UNASSIGN_ORGANIZATION_CONTACT_LABEL_BULK_FAIL],
        promise: client => client.post('api/labels/organization-contact/unassign/bulk', { data })
    }
}

export function assignAwardLabel(awardId, labelId) {
  return {
    types: [ASSIGN_AWARD_LABEL, ASSIGN_AWARD_LABEL_SUCCESS, ASSIGN_AWARD_LABEL_FAIL],
    promise: client => client.put(`api/labels/award/${awardId}/assign/${labelId}`, {})
  }
}

export function unassignAwardLabel(id) {
  return {
    types: [UNASSIGN_AWARD_LABEL, UNASSIGN_AWARD_LABEL_SUCCESS, UNASSIGN_AWARD_LABEL_FAIL],
    promise: client => client.del(`api/labels/award/unassign/${id}`, {})
  }
}

export function assignAwardLabelBulk(personIds, labelsIds) {
  const data = {
    personIds,
    labelsIds
  }

  return {
    types: [ASSIGN_AWARD_LABEL_BULK, ASSIGN_AWARD_LABEL_BULK_SUCCESS, ASSIGN_AWARD_LABEL_BULK_FAIL],
    promise: client => client.put('api/labels/award/assign/bulk', { data })
  }
}

export function unassignAwardLabelBulk(personIds, labelsIds) {
  const data = {
    personIds,
    labelsIds
  }

  return {
    types: [UNASSIGN_AWARD_LABEL_BULK, UNASSIGN_AWARD_LABEL_BULK_SUCCESS, UNASSIGN_AWARD_LABEL_BULK_FAIL],
    promise: client => client.post('api/labels/award/unassign/bulk', { data })
  }
}


export function setParams(options) {
    return {
        type: SET_PARAMS,
        options
    }
}
